import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FilterField } from '@features/file-explorer/components/Toolbar/filterTypes'

interface TextFilterInputProps {
  field: FilterField
  onSubmit: (value: string, valueLabel: string) => void
}

export function TextFilterInput({ field, onSubmit }: TextFilterInputProps) {
  const { t } = useTranslation()
  const [filterValue, setFilterValue] = useState('')

  const handleSubmit = () => {
    if (!filterValue) return
    onSubmit(filterValue, filterValue)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  }

  const inputType = field.type === 'date' ? 'date' : field.type === 'number' ? 'number' : 'text'

  return (
    <>
      <input
        type={inputType}
        value={filterValue}
        onChange={(e) => setFilterValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={t(`fileExplorer.filters.placeholders.${field.type}Value`)}
        className="input input-bordered input-sm w-full"
        autoFocus
      />
      <button
        onClick={handleSubmit}
        disabled={!filterValue}
        className="btn btn-primary btn-sm w-full mt-2"
      >
        {t('fileExplorer.filters.addFilter')}
      </button>
    </>
  )
}
